import Vue from "vue";
import Vuex from "vuex";

import getters from "./getters";
import user from "./modules/user";
import poi from "./modules/poi/index";
import search from "./modules/search/index";
import siderbar from "./modules/siderbar/index";
import truck from "./modules/truck/index";
import filter from "./modules/filter/index";
import map from "./modules/map/index";
import poiDetail from "./modules/poi-detail/index";
import tripPlan from "./modules/trip-plan/index";
import team from "./modules/team/index";
import card from "@/store/modules/card";
import subscription from "@/store/modules/subscription";
import company from "@/store/modules/company";
import cms from "./modules/cms";
import expense from "./modules/expense";
import team2 from "./modules/team2";
import dispatch from "../views/dispatchs/dispatch/store";
import im from "@/im/store";
import dc from "@/data-services/store";
import document2 from "./modules/document-v2/index";
import driver from "./modules/driver/index";
import permissionV2 from "./modules/permission-v2";
import assetManagement from "./modules/asset-management/index";
import eld from "@/eld/store";
import eld2 from "./modules/eld";
import basicInfo from './modules/basicInfo/index';
import contacts from "./modules/contacts/index";
import dashboard from './modules/dashboard/index'
import loadBoard from './modules/load-boards';
import accounting from "@/views/accounting/store";
import tracking from '@/views/dispatchs/dispatch/store/tracking'
import dispatchSearch from '@/views/dispatchs/dispatch/store/dispatch-search'
import schedule from './modules/schedule/index' 
import paymentv2 from './modules/payment-v2/index'
import invoice from './modules/invoice/index'
import ifta from '@/views/ifta/store'
import quickbooks from './modules/quickbooks/index'
import shareTracking from './modules/share-tracking'
import LBPremium from './modules/LB-premium'
import {storeAdapter$} from "@/store/adapter";
import mapWeather from "./modules/map-weather/index";

Vue.use(Vuex);

const defaultLocation = { latitude: 41.6179, longitude: -90.7815 }; // 默认的地理位置

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {
    localLocation: { latitude: null, longitude: null }, // 本地的地理位置
    inUseLocation: defaultLocation, // 采用的地理位置
  },
  mutations: {
    SET_LOCAL_LOCATION(state, data) {
      state.localLocation = data;
    },
    SET_IN_USE_LOCATION(state, data) {
      state.inUseLocation = data;
    },
  },
  actions: {
    /**
     * 获取用户当前的地理位置
     */
    getLocalLocation({ commit }) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const location = { latitude, longitude };
            commit("SET_IN_USE_LOCATION", location);
            commit("SET_LOCAL_LOCATION", location);
          },
          (error) => {
            console.log(error);
          },
          {
            maximumAge: 0, // 禁用缓存
            timeout: 30000, // 开始获取定位信息30秒后超时
          }
        );
      }
    },
  },
  modules: {
    user,
    poi,
    search,
    siderbar,
    truck,
    filter,
    map,
    poiDetail,
    tripPlan,
    team,
    card,
    subscription,
    company,
    cms,
    permissionV2,
    team2,
    eld,
    eld2,
    dispatch,
    document2,
    driver,
    assetManagement,
    basicInfo,
    contacts,
    dashboard,
    loadBoard,
    accounting,
    tracking,
    expense,
    schedule,
    dispatchSearch,
    paymentv2,
    invoice,
    ifta,
    quickbooks,
    shareTracking,
    LBPremium,
    mapWeather,
  },
  getters,
});

im.initStore(store);
dc.initStore(store);

storeAdapter$.subscribe(x => {
  store[x[0]](...x[1])
})
export default store;
